export const getSavedAction = (state) => state.savedAction;
